import React from 'react';

const Pagination = ({ 
    currentPage, 
    hasNextPage, 
    onLoadPrevious, 
    onLoadNext 
}) => {
    if (currentPage <= 1 && !hasNextPage) return null;

    return (
        <div className="flex justify-between items-center mt-8 p-4 bg-white rounded-lg w-full">
            {currentPage > 1 && (
                <PaginationButton
                    onClick={onLoadPrevious}
                    direction="previous"
                />
            )}
            <div className="flex-1"></div>
            {hasNextPage && (
                <PaginationButton
                    onClick={onLoadNext}
                    direction="next"
                />
            )}
        </div>
    );
};

const PaginationButton = ({ onClick, direction }) => {
    const baseClasses = `
        px-6 py-2 h-10
        bg-gradient-to-r from-[#0B6D76] to-[#09757F]
        text-white font-semibold
        rounded-lg
        shadow-lg
        hover:from-[#095C64] hover:to-[#0A6B73]
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#0B6D76]
        transition-all duration-300
        disabled:opacity-50 disabled:cursor-not-allowed
    `;

    return (
        <button onClick={onClick} className={baseClasses}>
            {direction === 'previous' ? '← Previous' : 'Next →'}
        </button>
    );
};

export default Pagination;
